export const LOAD_ROLLS_OUT = 'LOAD_ROLLS_OUT';
export const SET_ROLLS_OUT_FILTER = 'SET_ROLLS_OUT_FILTER';
export const SET_ROLLS_OUT_PAGINATION = 'SET_ROLLS_OUT_PAGINATION';
export const SET_ROLLS_OUT_SORT = 'SET_ROLLS_OUT_SORT';
export const RESET_ROLLS_OUT_FILTERS = 'RESET_ROLLS_OUT_FILTERS';
export const TOGGLE_ROLLS_OUT_STATUS = 'TOGGLE_ROLLS_OUT_STATUS';
export const CREATE_PALETTE_FROM_ROLLS_OUT = 'CREATE_PALETTE_FROM_ROLLS_OUT';
